<template>
  <div>
    <div v-if="$apollo.loading">
      <spinner />
    </div>
    <div v-else>
      <v-layout wrap>
        <v-flex class="screen-title mb-0" xs12>
          <span>{{ adminText('workflowsAll.event_entries_e553cd1', 'Event Entries') }}</span>
        </v-flex>
        <v-flex>
          <div class="mb-32 title-description">
            {{ adminText('workflowsAll.here_you_can_see_all_the_attendees_of_your_ev_5586dc5', 'Here you can see all the attendees of your event which have checked in.') }}
          </div>
        </v-flex>
        <v-flex xs12>
          <data-table
            :items="displayedRows"
            item-clickable
            :headers="workflowUi([
              { text: adminText('workflowsAll.name_709a232', 'Name'), align: 'left', value: 'firstName' },
              { text: adminText('workflowsAll.last_name_adec36a', 'Last name'), align: 'left', value: 'lastName' },
              { text: adminText('workflowsAll.status_bae7d5b', 'Status'), align: 'left', value: 'status' },
              { text: adminText('workflowsAll.time_of_entry_0731cde', 'Time of entry'), align: 'left', value: 'createdAt' },
            ])"
            @item-click="
              goTo(routes.organizer.editAccreditation, {
                eventId: eventId,
                accreditationUuid: $event.uuid || $event.id,
              })
            "
          />
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import DataTable from '../shared/data-table'
import Spinner from '../shared/spinner'
import { GET_SCANNED_ATTENDEES } from '../../graphql/scans.graphql'

export default {
  mixins: [WorkflowDisplay],
  name: 'scanned-attendees-container',
  components: {
    Spinner,
    DataTable,
  },
  props: {
    eventId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      attendees: [],
    }
  },
  computed: {
    displayedRows() {
      return this.attendees.map(item => ({ ...item, createdAt: this.workflowDate(item.createdAt, 'LL, H:mm') }))
    },
  },
  apollo: {
    getScannedAttendees: {
      query: GET_SCANNED_ATTENDEES,
      variables() {
        return {
          eventId: this.eventId,
        }
      },
      manual: true,
      result({ loading, data }) {
        if (!loading) {
          const { getScannedAttendees: scannedAttendees } = data
          if (!scannedAttendees) {
            return (this.attendees = [])
          }
          this.attendees =
            scannedAttendees && scannedAttendees.length > 0
              ? scannedAttendees.map(this.mapScannedAttendee)
              : []
        }
      },
    },
  },
  methods: {
    mapScannedAttendee(s) {
      const { attendee, ...rest } = s
      const { status, createdAt } = rest

      return {
        createdAt,
        status: status.toUpperCase(),
        ...attendee,
      }
    },
  },
}
</script>

<style></style>
